import { getRange, setRange } from "./selectionRange";

export const getCurrentSelectionPosition = parentElement => {
  return getRange(parentElement);
};

export const setCurrentSelectionPosition = (selectionPosition, element) => {
  if (!selectionPosition) return;
  return setRange(element, selectionPosition);
};
